import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Template1 from '../Template1/Template1';
import Template2 from '../Template2/Template2';
import Template3 from '../Template3/Template3';
import Template4 from '../Template4/Template4';
import Template5 from '../Template5/Template5';
import Template6 from '../Template6/Template6';
import Template7 from '../Template7/Template7';

function getStoredPreviewForTemplateId(templateId) {
  try {
    // 1) Direct hit by template key
    const direct = localStorage.getItem(`visibeen_template_${templateId}`);
    if (direct) return JSON.parse(direct);

    // 2) Search any stored preview created earlier per-profile
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (!k.startsWith('visibeen_website_')) continue;
      const raw = localStorage.getItem(k);
      const obj = raw ? JSON.parse(raw) : null;
      if (obj?.template?.id && String(obj.template.id) === String(templateId)) return obj;
    }

    // 3) Scan any visibeen_template_* entries
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (!k.startsWith('visibeen_template_')) continue;
      const raw = localStorage.getItem(k);
      const obj = raw ? JSON.parse(raw) : null;
      if (obj?.template?.id && String(obj.template.id) === String(templateId)) return obj;
    }

    // 4) Fallback: default key if exists
    const fallback = localStorage.getItem('visibeen_website_default');
    return fallback ? JSON.parse(fallback) : null;
  } catch (_) {
    return null;
  }
}

export default function LiveDemo() {
  const { templateId } = useParams();
  const data = useMemo(() => getStoredPreviewForTemplateId(templateId), [templateId]);

  const real = data?.template?.realData || data?.templateData || data?.realData || data?.template?.templateData;
  const id = Number(templateId || data?.template?.id || 1);

  if (!real) {
    return <div style={{ padding: 24 }}>No preview data found for template {templateId}. Please create the website from the Free Website page first.</div>;
  }

  if (id === 1) return <Template1 templateData={real} />;
  if (id === 2) return <Template2 templateData={real} />;
  if (id === 3) return <Template3 templateData={real} />;
  if (id === 4) return <Template4 templateData={real} />;
  if (id === 5) return <Template5 templateData={real} />;
  if (id === 6) return <Template6 templateData={real} />;
  if (id === 7) return <Template7 templateData={real} />;
  return <Template1 templateData={real} />;
}


